export default __webpack_public_path__ + "static/media/coin-flip.fa068c14.gif";